<template>
  <div v-if="hasProductRecommendations" class="product-recommendations">
    <div class="product-recommendations__header">
      <h2 class="product-recommendations__title">
        {{ heading }}
      </h2>
    </div>
    <div class="photos">
      <ProductQueryWrapper
        v-for="recommendation in recommendations"
        :key="recommendation.id"
        v-slot="{ product }"
        :product-id="recommendation.product_id"
      >
        <PhotoTile
          v-if="product"
          :product="productWithReferralPlacement(product)"
        />
      </ProductQueryWrapper>
    </div>
  </div>
</template>

<script>
import PhotoTile from "@/components/PhotoTile.vue";
import ProductQueryWrapper from "@/components/ProductQueryWrapper.vue";
export default {
  name: "NostoProductRecommendations",
  components: {
    PhotoTile,
    ProductQueryWrapper,
  },
  props: {
    recommendations: {
      type: Array,
      default: () => [],
    },
    heading: {
      type: String,
      required: true,
    },
    placement: {
      type: String,
      default: null,
    },
  },
  computed: {
    hasProductRecommendations() {
      return this.recommendations?.length >= 1;
    },
  },
  methods: {
    productWithReferralPlacement(product) {
      if (!this.placement) {
        return product;
      }

      const newOnlineStoreUrl = new URL(product.onlineStoreUrl);
      newOnlineStoreUrl.searchParams.set("ref-placement", this.placement);

      return {
        ...product,
        onlineStoreUrl: newOnlineStoreUrl,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.product-recommendations {
  background-color: $color-light;
  padding: 60px 0 0;

  @include respond-above(md) {
    padding: 80px 0 0;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 10px;
    padding: 0 10px;

    @include respond-above(md) {
      padding: 0 20px;
    }
  }

  &__title {
    text-transform: uppercase;
    font-size: 18px;
    font-weight: normal;

    @include respond-above(md) {
      font-size: 30px;
    }
  }

  &__link {
    font-size: 8px;
    text-decoration: none;
    text-transform: uppercase;
    color: $color-dark;
    font-weight: 600;

    @include respond-above(md) {
      font-size: 10px;
    }
  }
}

.photos {
  display: flex;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;

  & > * {
    flex: 1 0 87.5%;
    margin-right: 2px;

    @include respond-above(md) {
      flex: 1 0 40%;
    }
  }
}
</style>
